import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSortDown, faSortUp } from "@fortawesome/free-solid-svg-icons";
import { BodyAsFormData } from "../../../services/utilities/util";
import FilterContext from "../../../routes/FilterContext";
import { apiMiddleware } from "../../../services/apis/apiMiddleware";
import "jspdf-autotable";
import { connect } from "react-redux";
function mapStateToProps(state) {
  return { filters: state.selectedFilters };
}
class UnitAndRents extends React.Component {
  static contextType = FilterContext;

  state = {
    unitRents: [],
    filters: "",
  };

  componentDidMount() {
    var filters;
    if (JSON.stringify(this.props.filters) == "{}") {
      filters = JSON.stringify(this.context.filters);
    } else {
      filters = JSON.stringify(this.props.filters);
    }
    this.state.filters = filters;
    apiMiddleware
      .post(
        "api/edge/office/get_custom_units_and_rents",
        BodyAsFormData(filters)
      )
      .then((res) => {
        this.setState({ unitRents: res.data }, () => {
          console.log(this.state.unitRents);
        });
      });
  }

  componentDidUpdate() {
    if (this.props.filters != this.state.filters){
      this.setState({ filters: this.props.filters });

      apiMiddleware
        .post(
          "api/edge/office/get_custom_units_and_rents",
          BodyAsFormData(JSON.stringify(this.props.filters))
        )
        .then((res) => {
          this.setState({ unitRents: res.data });
        });
      console.log(this.state.unitRents);
    }
  }

  render() {
    return (
      <div className="container-fluid unitsRents">
        <div className="row">
          <div className="col-lg-12">
            <table className="table">
              <thead>
                <tr>
                  <th>Unit</th>
                  <th>Chargeable Area (sqft)</th>
                  <th>Carpet Area (sqft)</th>
                  <th>Initial Rent (₹)</th>
                  <th>Initial Rent (₹/sqft/month)</th>
                  <th>Market Average</th>
                </tr>
              </thead>
              <tbody>
                {Object.keys(this.state.unitRents).length > 0 &&
                  this.state.unitRents.rent_details.map((row, i) => (
                    <tr className="tableTdColor" key={i}>
                      <td>{row.unit_name}</td>
                      <td>{row.unit_chargeable_area_sf}</td>
                      <td>{row.unit_carpet_area_sf}</td>
                      <td>{row.unit_initial_rent_inr}</td>
                      <td>{row.unit_initial_rent_sft}</td>
                      <td>{row.unit_market_avg}</td>
                    </tr>
                  ))}
              </tbody>
              <tfoot>
                <tr>
                  <td>Payment Frequency</td>
                  <td colSpan={5}>{this.state.unitRents.payment_frequency}</td>
                </tr>
              </tfoot>
            </table>
          </div>
        </div>
      </div>
    );
  }
}

export default connect(mapStateToProps)(UnitAndRents);
